import React from 'react';
import './styles.css';

function NotAvailableModel() {
    return (
        <span className="empty-model">Não há modelo disponível para download</span>
    );
}

export default NotAvailableModel;